import { render, staticRenderFns } from "./ForbiddenView.vue?vue&type=template&id=81e0bea8&"
import script from "./ForbiddenView.vue?vue&type=script&lang=ts&"
export * from "./ForbiddenView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports